import { Box, Snackbar, Alert } from "@mui/material";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Header from "../../../components/Header";
import ExpensesForm from "../../../components/ExpensesForm";
import { useTranslation } from "react-i18next";

const CreateExpenses = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const [open, setOpen] = useState(false);
  const apiUrl = "https://oven-backend.onrender.com";


  const handleFormSubmit = async (values) => {
    try {
      const formattedValues = {
        ...values,
        date: values.date || new Date().toISOString(),
      };

      const response = await axios.post(`${apiUrl}/expenses`, formattedValues);
      setOpen(true);
      console.log("✅ Expense created successfully:", response.data);
      setTimeout(() => {
        navigate("/expenses");
      }, 1000);
    } catch (error) {
      console.error("❌ Error creating expense:", error.response?.data || error);
    }
  };

  return (
    <Box m="20px" sx={{ direction: isRTL ? "rtl" : "ltr" }}>
      <Header title={t("create_expense")} subtitle={t("create_expense_subtitle")} />
      <ExpensesForm 
        initialValues={{
          employee_id: "",
          category: "",
          amount: "",
          description: "",
          date: "",
        }}
        handleFormSubmit={handleFormSubmit} 
        buttonLabel={t("add_expense")}
      />
      <Snackbar open={open} autoHideDuration={6000} onClose={() => setOpen(false)}>
        <Alert onClose={() => setOpen(false)} severity="success" variant="filled" sx={{ width: '100%' }}>
          {t("expense_added_successfully")}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateExpenses;
